var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 339 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.63 161.041c0 26.568-21.546 48.103-48.13 48.103s-48.13-21.534-48.13-48.103c0-26.568 21.546-48.103 48.13-48.103s48.13 21.535 48.13 48.103zM339 169.405c0 65.483-84.05 202.747-136.092 281.436-4.301 6.505-8.381 12.602-12.17 18.228-8.945 13.258-16.302 23.882-21.238 30.93-4.941-7.049-12.293-17.672-21.238-30.93-3.788-5.626-7.869-11.723-12.169-18.228C84.05 372.152 0 234.889 0 169.405 0 75.995 76.033 0 169.5 0S339 75.995 339 169.405zm-73.241-8.364c0-53.133-43.097-96.206-96.259-96.206s-96.259 43.073-96.259 96.206 43.097 96.206 96.259 96.206 96.259-43.073 96.259-96.206z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.0cacba74b748d7d82c6b206925c601c4.svg";
export { ForwardRef as ReactComponent };